module.exports = __webpack_public_path__ + "static/img/LU.ab64b70c.png";